/* RESPONSIBLE TEAM: team-ai-agent */
import type AppService from 'embercom/services/app-service';
import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import RouteRegexes from 'embercom/lib/route-regexes';
import type Router from '@ember/routing/router-service';
import type AutomationNavCounts from 'embercom/services/automation-nav-counts';
import type NavbarCollapsingService from 'embercom/services/navbar-collapsing-service';

export default class FinAIAgentController extends Controller {
  queryParams = [];

  @service declare router: Router;
  @service declare appService: AppService;
  @service declare navbarCollapsingService: NavbarCollapsingService;
  @service declare contentImportService: any;
  @service declare automationNavCounts: AutomationNavCounts;

  get isOnFinAIAgentSetupRoute() {
    return RouteRegexes.finAIAgentSetup.test(this.router.currentRouteName);
  }

  get isOnFinAIAgentContentRoute() {
    return RouteRegexes.finAIAgentContent.test(this.router.currentRouteName);
  }

  get isOnFinAIAgentCustomAnswersRoute() {
    return RouteRegexes.finAIAgentCustomAnswers.test(this.router.currentRouteName);
  }

  get isOnFinAIAgentProfilesRoute() {
    return RouteRegexes.finAIAgentProfiles.test(this.router.currentRouteName);
  }

  get isOnFinAIAgentSettingsRoute() {
    return RouteRegexes.finAIAgentSettings.test(this.router.currentRouteName);
  }

  get isOnFinAIAgentAICategoriesRoute() {
    return RouteRegexes.finAIAgentAttributes.test(this.router.currentRouteName);
  }

  get numberOfPendingItemsToReview() {
    return this.contentImportService.aiContentReviewSummary.pending;
  }

  get allAnswersCount() {
    return this.automationNavCounts.allAnswersCount;
  }
}
